import Aos from 'aos'
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, EffectFade, Autoplay, Mousewheel, Parallax, Controller} from 'swiper/modules';
Swiper.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay, Mousewheel, Parallax, Controller]);

import "./swiperManager"
import SwiperManager from './swiperManager';

$(() => {
  // const swiperFv1 = new Swiper('.swiper-fv-01', {
  //   loop: true,
  //   effect: 'fade',
  //   autoplay: {
  //     delay: 4000,
  //     disableOnInteraction: false,
  //   },
  //   speed: 2000,
  // })

  // const swiperFv2 = new Swiper('.swiper-fv-02', {
  //   loop: true,
  //   effect: 'fade',
  //   autoplay: {
  //     delay: 4000,
  //     disableOnInteraction: false,
  //   },
  //   speed: 2000,
  // })

  // setInterval(() => {
  //   swiperFv1.slideNext()
  //   swiperFv2.slideNext()
  // }, 5000);

  new Swiper('.swiper-archive', {
    slidesPerView: 1,
    spaceBetween: 28,
    navigation: {
      nextEl: '.swiper-archive-next',
      prevEl: '.swiper-archive-prev',
    },
    scrollbar: {
      el: '.swiper-archive-scrollbar',
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 46,
      }
    },
    on: {
      init: function() {
        Aos.refreshHard()
      },
    },
    mousewheel: {
      forceToAxis: true,
    }
  })

  $('.section-pickup-slider').each(function() {
    new Swiper(this.querySelector('.swiper-interview'), {
      slidesPerView: 1,
      spaceBetween: 28,
      navigation: {
        nextEl: this.querySelector('.swiper-interview-next'),
        prevEl: this.querySelector('.swiper-interview-prev'),
      },
      scrollbar: {
        el: this.querySelector('.swiper-interview-scrollbar'),
        draggable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 46,
        }
      },
      on: {
        init: function() {
          Aos.refreshHard()
        },
      },
      mousewheel: {
        forceToAxis: true,
      }
    })
  })

  $('.section-new-contents').each(function() {
    new Swiper(this.querySelector('.swiper-interview'), {
      slidesPerView: 1,
      spaceBetween: 28,
      navigation: {
        nextEl: this.querySelector('.swiper-interview-next'),
        prevEl: this.querySelector('.swiper-interview-prev'),
      },
      scrollbar: {
        el: this.querySelector('.swiper-interview-scrollbar'),
        draggable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          spaceBetween: 72,
        }
      },
      on: {
        init: function() {
          Aos.refreshHard()
        },
      },
      mousewheel: {
        forceToAxis: true,
      }
    })
  })

  new Swiper('.swiper-gallery', {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '.swiper-gallery-next',
      prevEl: '.swiper-gallery-prev',
    },
    on: {
      init: function() {
        Aos.refreshHard()
      },
    },
  })

  new Swiper('.swiper-about-us', {
    slidesPerView: 'auto',
    loop: true,
    spaceBetween: 24,
    speed: 8000,
    autoplay: {
      delay: 0,
    },
    on: {
      init: function() {
        Aos.refreshHard()
      },
    },
    breakpoints: {
      768: {
        spaceBetween: 44,
      }
    }
  })


  new Swiper('.swiper-emisil-fv', {
    loop: true,
    // If we need pagination
    pagination: {
      el: '.swiper-emisil-fv-pagination',
      clickable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })


})
